<template>
  <div>
    <!-- <div class="tabs">
      <div
        class="tab"
        @click="selectType(1)"
        :class="{ active: selectedType === 1 }"
      >
        <strong>기록</strong>
      </div>
      <div
        class="tab"
        @click="selectType(2)"
        :class="{ active: selectedType === 2 }"
      >
        <strong>나이대</strong>
      </div>
    </div> -->
    <!-- //tabs -->

    <div class="calcul">
      <!-- 시간(초) 내용 -->
      <div v-show="selectedType === 1">
        <div class="etc-div">
          <strong class="tit-unit">본인 기록 입력</strong>
          <ul>
            <li>
              <button class="etcBtn" @click="selectDistanceEtc(1.5)">
                <strong>1.5</strong>km
              </button>
            </li>
            <li>
              <button class="etcBtn" @click="selectDistanceEtc(5)">
                <strong>5</strong>km
              </button>
            </li>
            <li>
              <button class="etcBtn" @click="selectDistanceEtc(10)">
                <strong>10</strong>km
              </button>
            </li>
            <li>
              <button class="etcBtn" @click="selectDistanceEtc(21.1)">
                <strong>half</strong>
              </button>
            </li>
            <li>
              <button class="etcBtn" @click="selectDistanceEtc(42.2)">
                <strong>full</strong>
              </button>
            </li>
          </ul>
        </div>

        <div
          class="time-inputs no-line"
          :class="{ disabled: selectedDistance === 0 }"
        >
          <div class="time-inputs-div">
            <select
              id="hours"
              v-model="hours"
              :disabled="selectedDistance === 0"
            ></select>
          </div>
          <span class="unit">시</span>
          <div class="time-inputs-div">
            <select
              id="minutes"
              v-model="minutes"
              :disabled="selectedDistance === 0"
            ></select>
          </div>
          <span class="unit">분</span>
          <div class="time-inputs-div">
            <select
              id="seconds"
              v-model="seconds"
              :disabled="selectedDistance === 0"
            ></select>
          </div>
          <span class="unit">초</span>
        </div>
      </div>
      <!-- //selectedType === 1 -->

      <div v-show="selectedType === 2">2222</div>
      <!-- //selectedType === 2 -->

      <p class="txt-help">※ 자료 출처 - Jack Daniels의 러닝 공식</p>
      <div class="calcul-bottom">
        <button
          id="calculateButton"
          @click="calculateResult"
          :disabled="isCalculateDisabled"
        >
          계산
        </button>
      </div>
    </div>
    <!-- //calcul -->

    <div class="goal-div" v-show="showGoalDiv">
      <h3>예상 기록</h3>
      <ul>
        <li>
          <span>vo2max</span>
          <strong>{{ vo2max.toFixed(1) }} <i>(ml/kg/min)</i></strong>
        </li>
        <li v-for="(time, distance) in predictedTimes" :key="distance">
          <span>{{ distance }}</span>
          <strong>{{ time }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "VO2MaxCalculator",
  data() {
    return {
      selectedType: 1,
      selectedDistance: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      showGoalDiv: false,
      vo2max: 0,
      predictedTimes: {},
      selectedColumn: "",
      tableData: [
        //12:50
        { METS: 5.5, VO2max: 19.25, "1500": 750, "5000": 2640, "10000": 5490, half: 12000, full:24000  },
        { METS: 6, VO2max: 21, "1500": 690, "5000": 2460, "10000": 5160, half: 11400, full:22800  },
        { METS: 6.5, VO2max: 22.75, "1500": 645, "5000": 2310, "10000": 4845, half: 10500, full:21600  },
        { METS: 7, VO2max: 24.5, "1500": 610, "5000": 2175, "10000": 4500, half: 9900, full:20400  },
        { METS: 7.5, VO2max: 26.25, "1500": 570, "5000": 2055, "10000": 4290, half: 9600, full:19200  },
        { METS: 8, VO2max: 28, "1500": 540, "5000": 1950, "10000": 4050, half: 9000, full:18300  },
        { METS: 8.5, VO2max: 29.75, "1500": 510, "5000": 1860, "10000": 3855, half: 8400, full:17400  },
        { METS: 9, VO2max: 31.5, "1500": 490, "5000": 1770, "10000": 3675, half: 8100, full:16800  },
        { METS: 9.5, VO2max: 33.25, "1500": 465, "5000": 1695, "10000": 3510, half: 7800, full:16200  },
        { METS: 10, VO2max: 35, "1500": 445, "5000": 1620, "10000": 3360, half: 7500, full:15600  },
        { METS: 10.5, VO2max: 36.75, "1500": 425, "5000": 1560, "10000": 3235, half: 7200, full:15000  },
        { METS: 11, VO2max: 38.5, "1500": 410, "5000": 1500, "10000": 3105, half: 6900, full:14400  },
        { METS: 11.5, VO2max: 40.25, "1500": 395, "5000": 1440, "10000": 2985, half: 6600, full:13800  },
        { METS: 12, VO2max: 42, "1500": 380, "5000": 1395, "10000": 2895, half: 6300, full:13200  },
        { METS: 12.5, VO2max: 43.75, "1500": 365, "5000": 1335, "10000": 2775, half: 6300, full:12900  },
        { METS: 13, VO2max: 45.5, "1500": 350, "5000": 1290, "10000": 2685, half: 6000, full:12300  },
        { METS: 13.5, VO2max: 47.25, "1500": 340, "5000": 1260, "10000": 2595, half: 5700, full:12000  },
        { METS: 14, VO2max: 49, "1500": 330, "5000": 1215, "10000": 2520, half: 5700, full:11700  },
        { METS: 14.5, VO2max: 50.75, "1500": 320, "5000": 1185, "10000": 2455, half: 5400, full:11400  },
        { METS: 15, VO2max: 52.5, "1500": 310, "5000": 1155, "10000": 2395, half: 5400, full:11100  },
        { METS: 15.5, VO2max: 54.25, "1500": 300, "5000": 1125, "10000": 2310, half: 5100, full:10800  },//3시간
        { METS: 16, VO2max: 56, "1500": 295, "5000": 1110, "10000": 2250, half: 5100, full:10500  },
        { METS: 16.5, VO2max: 57.75, "1500": 285, "5000": 1055, "10000": 2190, half: 4800, full:10200  },
        { METS: 17, VO2max: 59.5, "1500": 275, "5000": 1030, "10000": 2130, half: 4800, full:9900  },
        { METS: 17.5, VO2max: 61.25, "1500": 270, "5000": 1015, "10000": 2095, half: 4620, full:9600  },
        { METS: 18, VO2max: 63, "1500": 265, "5000": 980, "10000": 2030, half: 4500, full:9420  },
        { METS: 18.5, VO2max: 64.75, "1500": 260, "5000": 955, "10000": 1995, half: 4380, full:9180  },
        { METS: 19, VO2max: 66.5, "1500": 250, "5000": 935, "10000": 1930, half: 4320, full:9000  },
        { METS: 19.5, VO2max: 68.25, "1500": 245, "5000": 915, "10000": 1915, half: 4200, full:8760  },
        { METS: 20, VO2max: 70, "1500": 240, "5000": 900, "10000": 1860, half: 4080, full:8640  },
        { METS: 20.5, VO2max: 71.75, "1500": 235, "5000": 875, "10000": 1830, half: 4020, full: 8400 },
        { METS: 21, VO2max: 73.5, "1500": 230, "5000": 860, "10000": 1785, half: 3960, full: 8220 },
        { METS: 21.5, VO2max: 75.3, "1500": 225, "5000": 840, "10000": 1755, half: 3840, full: 8100 },
        { METS: 22, VO2max: 77.0, "1500": 220, "5000": 825, "10000": 1710, half: 3780, full: 7920 },
        { METS: 22.5, VO2max: 78.8, "1500": 217, "5000": 810, "10000": 1680, half: 3720, full: 7800 },
        { METS: 23, VO2max: 80.5, "1500": 213, "5000": 795, "10000": 1650, half: 3660, full: 7680 },
        { METS: 23.5, VO2max: 82.3, "1500": 209, "5000": 780, "10000": 1620, half: 3600, full: 7500 },
        { METS: 24, VO2max: 84.0, "1500": 206, "5000": 765, "10000": 1590, half: 3540, full: 7380 }
      ],
    };
  },
  mounted() {
    this.populateTimeOptions("hours", 0, 6); // 시
    this.populateTimeOptions("minutes", 0, 59); // 분
    this.populateTimeOptions("seconds", 0, 59); // 초
  },
  computed: {
    isCalculateDisabled() {
      return (
        this.selectedDistance === 0 ||
        (this.hours === 0 && this.minutes === 0 && this.seconds === 0)
      );
    },
  },
  methods: {
    selectType(type) {
      this.selectedType = type;
    },
    selectDistanceEtc(value) {
      const distanceMapping = {
        1.5: "1500",
        5: "5000",
        10: "10000",
        21.1: "half",
        42.2: "full",
      };

      // 선택된 거리 매핑 값 설정
      this.selectedColumn = distanceMapping[value] || null;
      this.selectedDistance = value;
      document.querySelectorAll(".etcBtn").forEach((tab) =>
        tab.classList.remove("active")
      );
      event.target.classList.add("active");
    },
    populateTimeOptions(elementId, start, end, initialValue = start) {
      const selectElement = document.getElementById(elementId);
      // 기존 옵션 제거
      selectElement.innerHTML = "";
      for (let i = start; i <= end; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = `${i}`;
        if (i === initialValue) {
          option.selected = true; // 초기값 설정
        }
        selectElement.appendChild(option);
      }
    },
    
    calculateResult() {
      if (this.selectedType === 1) {
        const timeInSeconds = this.convertToSeconds(this.hours, this.minutes, this.seconds);
        let vo2max = 0;
        let predictedTimes = {};
        // let lowerEntry = null;
        // let upperEntry = null;

        const selectedColumn = this.selectedColumn; // 예: '1500', '5000', '10000' 등
        
        if (!selectedColumn) {
          console.error("선택된 거리 값이 없습니다.");
          return;
        }

        // 선택된 거리 항목의 timeInSeconds와 일치하는 테이블 항목 찾기
        let matchingRow = null;
        for (let i = 0; i < this.tableData.length; i++) {
          const row = this.tableData[i];
          if (row[selectedColumn] === timeInSeconds) {
            matchingRow = row;
            break;
          }
        }

        // 일치하는 값이 없는 경우 처리
        if (!matchingRow) {
          let selectedRow;
          for (let i = 0; i < this.tableData.length; i++) {
            const row = this.tableData[i];
            if (row[selectedColumn] < timeInSeconds) {
              selectedRow = i;
              console.log(selectedRow)
              break;
            }
          }
          if(!selectedRow){
            alert("범위밖의 값입니다.")
            return;
          }
          let t = this.tableData[selectedRow-1][selectedColumn] - this.tableData[selectedRow][selectedColumn];
          let c = timeInSeconds - this.tableData[selectedRow][selectedColumn];
          let ratio = (c/t);
          
          vo2max = this.ratioRowConvert(this.tableData[selectedRow].VO2max, this.tableData[selectedRow-1].VO2max, ratio);
          predictedTimes["1.5km"] = this.formatTime(this.ratioRowConvert(this.tableData[selectedRow]["1500"], this.tableData[selectedRow-1]["1500"], ratio));
          predictedTimes["5km"] = this.formatTime(this.ratioRowConvert(this.tableData[selectedRow]["5000"], this.tableData[selectedRow-1]["5000"], ratio));
          predictedTimes["10km"] = this.formatTime(this.ratioRowConvert(this.tableData[selectedRow]["10000"], this.tableData[selectedRow-1]["10000"], ratio));
          predictedTimes["half"] = this.formatTime(this.ratioRowConvert(this.tableData[selectedRow]["half"], this.tableData[selectedRow-1]["half"], ratio));
          predictedTimes["full"] = this.formatTime(this.ratioRowConvert(this.tableData[selectedRow]["full"], this.tableData[selectedRow-1]["full"], ratio));
        }else{
          // VO2max 및 예상 기록 계산
          vo2max = matchingRow.VO2max;
          predictedTimes["1.5km"] = this.formatTime(matchingRow["1500"]);
          predictedTimes["5km"] = this.formatTime(matchingRow["5000"]);
          predictedTimes["10km"] = this.formatTime(matchingRow["10000"]);
          predictedTimes["half"] = this.formatTime(matchingRow["half"]);
          predictedTimes["full"] = this.formatTime(matchingRow["full"]);
        }

        

        this.vo2max = vo2max;
        this.predictedTimes = predictedTimes;
        this.showGoalDiv = true;
      } else if (this.selectedType === 2) {
        console.log("나이대 계산 로직을 추가하십시오.");
      }
    },
    ratioRowConvert(upperData, lowerData, ratio){
      let t = lowerData - upperData
      return t * ratio + upperData
    },
    interpolateTime(lowerTime, upperTime, ratio) {
      const interpolatedTime = lowerTime + ratio * (upperTime - lowerTime);
      return this.formatTime(Math.round(interpolatedTime));
    },
    // 시간(초)을 hh:mfull:ss 형식으로 변환
    formatTime(seconds) {
      seconds = Math.floor(seconds); // 소수점 제거
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      let formattedTime = '';

      if (hours > 0) {
        formattedTime += `${hours}:`;
      }

      if (minutes > 0 || hours > 0) {
        formattedTime += `${minutes < 10 && hours > 0 ? '0' : ''}${minutes}:`;
      }

      formattedTime += `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;

      return formattedTime;
    },
    
    // 시간(초)을 계산하는 함수
    convertToSeconds(hours, minutes, seconds) {
      return Number(hours * 3600) + Number(minutes * 60) + Number(seconds);
    }
  },
};
</script>



  
<style scoped>
.calcul{
  border-radius:0.8em;
}
.etc-div {
  height: auto;
}
.time-inputs {
  margin-top: 25px;
}

.etc-div .etcBtn.active {
  color: #e11b22;
}
.time-inputs.disabled {
  opacity: 0.3;
}
.goal-div > ul > li > span {
  width: 5em;
}
.goal-div > ul > li > span {
  font-size: 0.8em;
}
</style>